import { FormField, FormItem, FormLabel } from '@cobliteam/ui/form';
import AppCodeWrapper from './AppCodeWrapper';
import AppPopover from './AppPopover';

const DriverAppAccess = () => (
  <FormField name='driverCode'>
    {({ field }) => (
      <FormItem className='w-fit shrink-0 space-y-1'>
        <div className='flex flex-col gap-1'>
          <div className='flex items-center'>
            <FormLabel>Acesso ao App</FormLabel>
            <AppPopover portal={false} />
          </div>
          <AppCodeWrapper driverCode={field.value} />
        </div>
      </FormItem>
    )}
  </FormField>
);

export default DriverAppAccess;
